const MATCH_TRIGGER = '[data-details-modal="trigger"]'
const MATCH_CLOSE = '[data-details-modal="close"]'
const OPEN = 'is-open'
const ESC = 27

let $current = null

export default function () {
  document.addEventListener('click', onClick)
  document.addEventListener('keydown', onKey)
}

function onClick (event) {
  let $target = event.target

  if ($target.matches(MATCH_TRIGGER)) {
    handleTrigger(event)
  }
  if ($target.matches(MATCH_CLOSE)) {
    handleClose(event)
  }
}

function onKey ({ keyCode }) {
  if (keyCode === ESC) handleClose()
}

function handleTrigger (event) {
  let $target = event.target
  let id = $target.getAttribute('href').slice(1)

  if ($current != null) handleClose()

  $current = document.getElementById(id)
  $current.classList.add(OPEN)
  event.preventDefault()
}

function handleClose (event) {
  if ($current == null) return

  $current.classList.remove(OPEN)
  $current = null
  if (event) event.preventDefault()
}
